import React, { useState, useEffect } from 'react'

const Tabs = ({ children, defaultTab }) => {
    const [activeTab, setActiveTab] = useState(defaultTab)

    useEffect(() => {
        if (defaultTab) {
            setActiveTab(defaultTab)
        }
    }, [defaultTab])

    // Find children that are Tabs.Tab components
    const tabElements = React.Children.toArray(children)

    return (
        <div className="w-full">
            <div className="flex border-b border-stroke dark:border-strokedark mb-6">
                {tabElements.map((child) => {
                    if (!child.props) return null
                    const { value, label } = child.props
                    if (!value || !label) return null
                    
                    return (
                        <button
                            key={value}
                            className={`py-4 px-6 text-sm font-medium transition-all border-b-2 ${
                                activeTab === value
                                    ? 'border-primary text-primary'
                                    : 'border-transparent text-gray-500 hover:text-primary'
                            }`}
                            onClick={() => setActiveTab(value)}
                        >
                            {label}
                        </button>
                    )
                })}
            </div>
            <div className="tab-content">
                {tabElements.find((child) => child.props && child.props.value === activeTab)?.props.children}
            </div>
        </div>
    )
}

Tabs.Tab = ({ children }) => {
    return <>{children}</>
}

export default Tabs
